export default {
  en: {
    login: 'Sign in',
    ariaLabel: 'Sign In Form',
    signUp: 'Sign up',
    forms: {
      signIn: 'Sign in',
      password: 'Password',
      username: 'Username',
    },
    messages: {
      noAccount: 'New on Eventtia? ',
      forgotPassword: 'Forgot Password? ',
      loggedIn: 'Logged in successfully',
      loggedOut: 'Logged out successfully',
    },
    actions: {
      clickHere: 'Click here',
    },
    errors: {
      unexpected: 'An unexpected error has occurred. Please try again later.',
    },
  },
  es: {
    forms: {
      signIn: 'Sign in',
      password: 'Password',
      username: 'Username',
    },
  },
  fr: {},
  de: {},
};
